import { twMerge } from 'tailwind-merge';

import Skeleton from '../Skeleton';

type Props = {
  variant?: 'amount' | 'link';
  className?: string;
};

const shell = 'rounded-2 border-gray-light bg-white p-5';

const AmountSkeleton = () => (
  <>
    <Skeleton className="h-8 w-20" />
    <Skeleton className="mt-1 h-5 w-40" />
  </>
);

const LinkSkeleton = () => (
  <div className="flex h-full flex-col">
    <Skeleton className="h-5 w-32" />
    <Skeleton className="mt-1 h-4 w-36" />
    <div className="mt-auto flex justify-end pt-3">
      <Skeleton className="h-4 w-4" />
    </div>
  </div>
);

const DiscountTileSkeleton = ({ variant = 'amount', className }: Props) => (
  <div className={twMerge(shell, className)}>{variant === 'link' ? <LinkSkeleton /> : <AmountSkeleton />}</div>
);

export default DiscountTileSkeleton;
